import { Suspense, useState } from "react";
import { Route, Routes } from "react-router-dom";
import AddressesDetailsBody from "./components/customer/address/AddressesDetailsBody";
import AppBody from "./components/customer/body/AppBody";
import Cart from "./components/customer/cart/Cart";
import FabricInquiriesBody from "./components/customer/fabric-Inquiry/FabricInquiriesBody";
import FabricInquiryNewBody from "./components/customer/fabric-Inquiry/FabricInquiryNewBody";
import MyInquiryBody from "./components/customer/fabric-Inquiry/MyInquiryBody";
import { ForgotPassword } from "./components/customer/forget-password/ForgetPassword";
import LoyaltyPointDetails from "./components/customer/Loyalty/LoyaltyPointDetails";
import PlaceOrdersBody from "./components/customer/orders/PlaceOrdersBody";
import SpecificPlaceOrder from "./components/customer/orders/SpecificPlaceOrder";
import ProductDetailsBody from "./components/customer/productDetailsPage/ProductDetailsBody";
import ProfileDetailsBody from "./components/customer/profilePage/ProfileDetailsBody";
import Checkout from "./components/customer/Shipping/Checkout";
import Policy from "./components/customer/Shipping/Policy";
import SignUpDetailsBody from "./components/customer/signUpDetails/SignUpDetailsBody";
import SignUpVendorBody from "./components/customer/signUpDetails/SignUpVendorBody";
import PrivacyPolicyy from "./components/customer/Terms/PrivacyPolicyy";
import TermsAndConditions from "./components/customer/Terms/TermsAndConditions";
import Wallet from "./components/customer/Wallet/Wallet";
import WishListBody from "./components/customer/whislist/WishListBody";
import Layout from "./components/layout/Layout";
import { Login } from "./components/login/Login";
import WebsiteBody from "./components/website/WebSiteBody";
import CustomerDashboard from "./CustomerDashboard";
import ProtectedRoute from "./ProtectedRoute";
import ScrollToTop from "./utils/ScrollTop";
import Approved from "./Vendor/Approved";
import Draft from "./Vendor/Draft";
import InProgress from "./Vendor/InProgress";
import CreateProduct from "./Vendor/product/CreateProduct";
import VendorCreateProduct from "./Vendor/VendorCreateProduct";
import VendorHome from "./Vendor/VendorHome";
import MapProduct from "./Vendor/product/MapProduct";
import CreateMappedProduct from "./Vendor/product/CreateMappedProduct";
import PurchaseView from "./Vendor/PurchaseView";
import SalesOrderTable from "./Vendor/SalesOrderTable";
import SalesOrderPayment from "./Vendor/SalesOrderPayment";
import SalesTermsRemarks from "./Vendor/SalesTermsRemarks";
import SalesHeader from "./Vendor/SalesHeader";
import SalesHeaderTable from "./Vendor/SalesHeaderTable";
import VendorProducts from "./Vendor/product/VendorProducts";
import ShipmentPolicy from "./components/customer/Terms/ShipmentPolicy";
import AppBody2 from "./components/customer/body/AppBody2";
import AccountDelete from "./components/customer/signUpDetails/AccountDelete";
import Notfound from "./components/common/Notfound";
import VendorFabricInquiryNewDetails from "./components/customer/fabric-Inquiry/VendorFabricInquiryNewDetails";
import VendorFabricInquiriesBody from "./components/customer/fabric-Inquiry/VendorFabricInquiriesBody";
import VendorFabricInquiryNewBody from "./components/customer/fabric-Inquiry/VendorFabricInquiryNewBody";
import MyVendorInquiryDetails from "./components/customer/fabric-Inquiry/MyVendorInquiryDetails";
import AllNotifications from "./AllNotifications";
import MadeToOrder from "./Vendor/product/MadeToOrder";
import MtoEnguiry from "./components/customer/orders/MtoEnguiry";
import VendorStockAvailability from "./Vendor/product/VendorStockAvailability";

function App() {
  const [headerKey, setHeaderKey] = useState(0);

  const reloadHeader = () => {
    setHeaderKey((prevKey) => prevKey + 1);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ScrollToTop />
      <Routes>
        <Route path="*" index element={<Notfound />} />
        <Route
          path="/"
          element={<Layout headerKey={headerKey} reloadHeader={reloadHeader} />}
        >
          <Route path="/" index element={<WebsiteBody />} />
          <Route path="/home" element={<WebsiteBody />} />
          <Route path="/login" element={<Login reloadHeader={reloadHeader} />} />
          <Route path="/signup" element={<SignUpDetailsBody />} />
          <Route path="/account-delete" element={<AccountDelete />} />
          <Route path="/SignUpVendor" element={<SignUpVendorBody />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/shipment-policy" element={<ShipmentPolicy />} />
          <Route path="/fabrics" element={<AppBody />} />
          <Route path="/collections" element={<AppBody2 />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<CustomerDashboard />} />
            <Route path="/notifications" element={<AllNotifications />} />
            <Route path="/VendorHome" element={<VendorHome />} />
            <Route path="/VendorProducts" element={<VendorProducts />} />
            <Route path="/cart" element={<Cart reloadHeader={reloadHeader} />} />
            <Route path="/fabrics/:pimUrl" element={<ProductDetailsBody reloadHeader={reloadHeader} />} />
            <Route path="/shipping" element={<Checkout headerKey={headerKey} reloadHeader={reloadHeader} />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/profile" element={<ProfileDetailsBody />} />
            <Route path="/addresses" element={<AddressesDetailsBody />} />
            <Route path="/fabricInquiries" element={<FabricInquiriesBody />} />
            <Route path="/vendorFabricInquiries" element={<VendorFabricInquiriesBody />} />
            <Route path="/fabricInquiry/new" element={<FabricInquiryNewBody />} />
            <Route path="/vendorFabricInquiry/new" element={<VendorFabricInquiryNewBody />} />
            <Route path="/fabric-MyInquiry" element={<MyInquiryBody />} />
            <Route path="/fabric-MyInquiry-Vendor" element={<MyVendorInquiryDetails />} />
            <Route path="/wishList" element={<WishListBody />} />
               <Route path="/mtoInguiry" element={<MtoEnguiry />} />
            <Route path="/place-Orders" element={<PlaceOrdersBody orderType={'WHOLESALE'} />} />
            <Route path="/place-Swatch" element={<PlaceOrdersBody orderType={'SWATCH'} />} />
            <Route path="/place-Sample" element={<PlaceOrdersBody orderType={'SAMPLE'} />} />
            <Route path="/order-Details" element={<SpecificPlaceOrder />} />
            <Route path="/VendorHome/createProduct" element={<VendorCreateProduct />} />
            <Route path="/loyalty" element={<LoyaltyPointDetails />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path='/createDraftProduct' element={<CreateProduct />} />
            <Route path='/draftMappedProduct' element={<CreateMappedProduct />} />
            <Route path='/Po-Sample' element={<Approved orderType={'SAMPLE'} />} />
            <Route path='/madeToOrder' element={<MadeToOrder />} />
              <Route path='/vendorStockAvailable' element={<VendorStockAvailability />} />
            <Route path='/Po-Swatch' element={<Approved orderType={'SWATCH'} />} />
            <Route path='/Po-WholeSale' element={<Approved orderType={'WHOLESALE'} />} />
            <Route path="/purchase-order-Details" element={<InProgress />} />
            <Route path='/mapProduct' element={<MapProduct />} />
            <Route path='/purchase/po-view' element={<PurchaseView />} />
            <Route path='/sales/salesOrderTable' element={<ProtectedRoute element={SalesOrderTable} />} />
            <Route path='/sales/salesOrderPayment' element={<ProtectedRoute element={SalesOrderPayment} />} />
            <Route path='/sales/salesTerms' element={<ProtectedRoute element={SalesTermsRemarks} />} />
            <Route path='/sales/salesHeader' element={<ProtectedRoute element={SalesHeader} />} />
            <Route path='/sales/salesHeaderTable' element={<ProtectedRoute element={SalesHeaderTable} />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
